/**
 * PostHog Analytics Client Configuration
 */

import posthog from 'posthog-js'

// PostHog is now bootstrapped by an inline snippet in `src/app/layout.tsx`
// so its global error handlers are installed before React hydrates and can
// catch pre-hydration "Application error" crashes. This function is kept as
// a no-op for backwards compatibility with any remaining callers.
export function initPostHog() {
  return
}

// Get PostHog instance. The inline bootstrap in layout.tsx sets up a stub on
// window.posthog that buffers calls until the real SDK loads; the imported
// posthog-js module attaches to that same instance once loaded.
export function getPostHog() {
  if (typeof window === 'undefined') return null
  return posthog
}

// Identify user after login
export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  const ph = getPostHog()
  if (!ph) return

  ph.identify(userId, {
    ...traits,
    // Remove any PII
    email: undefined, // Don't send email to PostHog
  })
}

// Reset user on logout
export function resetUser() {
  const ph = getPostHog()
  if (!ph) return
  ph.reset()
}

// Track custom event
export function trackEvent(eventName: string, properties?: Record<string, unknown>) {
  const ph = getPostHog()
  if (!ph) return

  ph.capture(eventName, {
    ...properties,
    timestamp: new Date().toISOString(),
  })
}

// Track page view manually (if needed)
export function trackPageView(pageName?: string) {
  const ph = getPostHog()
  if (!ph) return

  ph.capture('$pageview', {
    $current_url: window.location.href,
    page_name: pageName,
  })
}
